import { jsx as t } from "react/jsx-runtime";
import o from "./index.es5603.js";
import { Button as e } from "./index.es15.js";
const s = (r) => /* @__PURE__ */ t("div", { className: o.CTAContainer, children: /* @__PURE__ */ t(e, { testId: "cta-button", ...r, fullWidth: !0 }) });
export {
  s as MenuCTAItem
};
//# sourceMappingURL=index.es827.js.map
